import React from 'react'

import { Helmet } from 'react-helmet'

import PagesliderIntro from '../components/pageslider-intro'
import './introduction.css'

const Introduction = (props) => {
  const { increaseTrainingPercentage } = props;

  return (
    <div className="introduction-container">
      <Helmet>
        <title>Introduction - ORRS</title>
        <meta property="og:title" content="Introduction - ORRS" />
      </Helmet>
      <div className="home-header">
        <div className="header-content">
            <img id="logo" src="\external\ORRSLogos_1113.png" alt="Logo" />
            <h1 className="home-text">The Opioid Rapid Response System (ORRS)<sup className='trademark'>TM</sup></h1>
        </div>
    </div>
      <PagesliderIntro increaseTrainingPercentage={increaseTrainingPercentage} rootClassName="pageslider-intro-root-class-name2"></PagesliderIntro>
      <footer className="introduction-footer">
        <span className="introduction-text1">
          <span>
            The contents of this training were created by REAL Prevention. For
            inquiries on permission for use of these materials please contact
          </span>
          <span className="introduction-text3">hechtpsu@gmail.com.</span>
          <span>
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
        </span>
        <span className="introduction-text5 Content">
          Copyright (2021) REAL Prevention. All rights reserved.
        </span>
      </footer>
    </div>
  )
}

export default Introduction
